<script setup lang="ts">
import DashboardCard from "./DashboardCard.vue"
import DashboardEmptyState from "./DashboardEmptyState.vue"

withDefaults(
  defineProps<{
    empty?: boolean
    emptyCentered?: boolean
    emptyDescription: string
    emptyTitle: string
    error?: string
    loading?: boolean
  }>(),
  {
    emptyCentered: true
  }
)
</script>

<template>
  <div v-if="loading" class="grid gap-3" data-testid="loading-state">
    <div v-for="index in 3" :key="index" class="dashboard-card dashboard-card--static h-16 overflow-hidden">
      <USkeleton class="h-full bg-[rgba(241,243,242,0.045)]" />
    </div>
  </div>
  <DashboardCard v-else-if="error" variant="danger" static data-testid="error-state">
    <UAlert
      color="error"
      variant="soft"
      title="Dashboard data unavailable"
      :description="error"
      icon="i-ph-warning-circle"
      :ui="{
        root: 'border-0 bg-transparent p-0',
        icon: 'text-(--dash-danger)',
        title: 'text-(--dash-ink)',
        description: 'text-(--dash-muted)'
      }"
    />
  </DashboardCard>
  <DashboardCard
    v-else-if="empty"
    static
    data-testid="empty-state"
    :class="emptyCentered ? 'dashboard-empty-card--center' : ''"
  >
    <DashboardEmptyState :title="emptyTitle" :description="emptyDescription" :centered="emptyCentered" />
  </DashboardCard>
  <slot v-else />
</template>
